import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Property } from '@modules/universal-billing/properties/properties.interface';
import { Observable, tap } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { Apartment } from '@modules/universal-billing/apartments/apartments.interface';
import { ApartmentsService } from '@modules/universal-billing/apartments/apartments.service';
import { Table } from '@primeng/table';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalServiceOption } from '@shared/services/modal/modal.interface';
import { SharedModule } from '@primeng/api';
import {
  PropertyApartmentCardComponent
} from '@modules/universal-billing/properties/properties-table/property-apartment-card/property-apartment-card.component';
import { MoneyFormatPipe } from '@common/pipe/money-format.pipe';
import { PTableCellValueComponent } from '@primeng/table/components/p-table-cell-value/p-table-cell-value.component';
import { PaymentStatusBadgeDirective } from '@common/directive/payment-status.directive';
import { ResourceByIdPipe } from '@shared/pipes/resource-by-id.pipe';
import { RouterLink } from '@angular/router';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgCanDirective } from '@common/rbac/ng-can.directive';

@Component({
  selector: 'app-property-apartments',
  standalone: true,
  imports: [
    Table,
    TranslatePipe,
    SharedModule,
    PropertyApartmentCardComponent,
    MoneyFormatPipe,
    PTableCellValueComponent,
    PaymentStatusBadgeDirective,
    ResourceByIdPipe,
    RouterLink,
    NgbTooltip,
    NgCanDirective
  ],
  templateUrl: './property-apartments.component.html',
  styleUrl: './property-apartments.component.scss'
})
export class PropertyApartmentsComponent extends BasicTableComponent<Apartment> implements OnInit {
  @Input({required: true}) property: Property;
  @Output() reloadProperty = new EventEmitter();

  service = inject(ApartmentsService);

  getAll(params: any): Observable<PageResult<Apartment>> {
    params.buildingId = this.property.id;
    return super.getAll(params)
  }

  onAdd() {
    this.modalService.open(this.getCreateModalOptions()).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.reloadProperty.emit();
      }
    })
  }
  getCreateModalOptions(): ModalServiceOption {
    const options = super.getCreateModalOptions();
    options.componentOptions.property = this.property;
    return options;
  }

  getEditModalOptions(data: Apartment): ModalServiceOption {
    const options = super.getEditModalOptions(data);
    options.componentOptions.property = this.property;
    return options;
  }
}
